var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.043 15.469C13.5041 15.0591 14.199 15.0591 14.6602 15.469C14.9735 15.7474 15.4688 15.525 15.4688 15.1058V2.89442C15.4688 2.47522 14.9735 2.2528 14.6602 2.5313C14.199 2.94121 13.5041 2.94121 13.043 2.5313C12.5818 2.1214 11.8869 2.1214 11.4258 2.5313C10.9646 2.94121 10.2697 2.94121 9.80859 2.5313C9.34744 2.1214 8.65256 2.1214 8.19141 2.5313C7.73026 2.94121 7.03536 2.94121 6.57422 2.5313C6.11308 2.1214 5.41817 2.1214 4.95703 2.5313C4.49589 2.94121 3.80099 2.94121 3.33984 2.5313C3.02653 2.2528 2.53125 2.47522 2.53125 2.89442V15.1058C2.53125 15.525 3.02653 15.7474 3.33984 15.469C3.80099 15.0591 4.49589 15.0591 4.95703 15.469C5.41817 15.8789 6.11308 15.8789 6.57422 15.469C7.03536 15.0591 7.73026 15.0591 8.19141 15.469C8.65256 15.8789 9.34744 15.8789 9.80859 15.469C10.2697 15.0591 10.9646 15.0591 11.4258 15.469C11.8869 15.8789 12.5818 15.8789 13.043 15.469Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 11.5156H12.2344",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 9H12.2344",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 6.48438H12.2344",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscription-icon.618fc18b1df8ae1dbb06e5c2d1273428.svg";
export { ForwardRef as ReactComponent };